import { ViewState } from '../states';

/**
 * The knowledge explorer's non-happy-path renderer (spec §11).
 *
 * This used to be its own implementation of the eight mandated states. It now
 * delegates to the app-wide `<ViewState>`, which grew out of the same design
 * and covers a strict superset of the cases — keeping two renderers meant the
 * explorer would drift away from every other surface the first time one of
 * them changed. The wrapper stays so the nine call sites keep their local
 * `.etch-knowledge__state` styling hook and their existing prop names.
 *
 * @param {object} props
 * @param {'loading'|'partial'|'empty'|'error'|'offline'|'permission'|'session'|'noSource'|'staleSource'} props.status
 * @param {string} [props.title] - overrides the default headline for the status.
 * @param {import('react').ReactNode} [props.description]
 * @param {unknown} [props.error] - technical detail, rendered as secondary copy only.
 * @param {() => void} [props.onRetry] - renders the retry button when present.
 * @param {import('react').ReactNode} [props.action] - extra action next to retry.
 * @param {boolean} [props.compact] - denser variant for the narrow rail.
 */
export function PanelState({ status, title, description, error, onRetry, action, compact = false }) {
  return (
    <ViewState
      className="etch-knowledge__state"
      status={status}
      title={title}
      description={description}
      error={error}
      onRetry={onRetry}
      action={action}
      compact={compact}
    />
  );
}

export default PanelState;
